import {
    communicationBaseDefaultValues,
    CommunicationBaseFormType,
} from "@/components/organisms/Forms/Communication/formType";
import {
    identityCardBaseDefaultValues,
    IdentityCardBaseFormType,
} from "@/components/organisms/Forms/IdentityCard/formType";

export interface FormType extends CommunicationBaseFormType, IdentityCardBaseFormType {
    id: number;

    relationType: string;
    firstName: string;
    lastName: string;

    socialStatus: string;
    language: string;
    birthdate: Date;
    birthPlace: string;
    civilStatus: string;
    gender: string;
    title: string;

    financeAccountType: string;
    financeAccount: string;

    driversLicense: string;
    driversLicenseNumber: string;
    driversLicenseIssueDate: Date;
    driversLicenseType: string;
    driversLicenseIssueCountry: string;
}

export const personalInfoDefaultValues = {
    socialStatus: "",
    language: "",
    birthdate: null,
    birthPlace: "",
    civilStatus: "",
    gender: null,
    title: "",
};

export const personDefaultValues = {
    relationType: "",
    firstName: "",
    lastName: "",
};

export const financeDefaultValues = {
    financeAccountType: "",
    financeAccount: "",
};

export const driverLicenseDefaultValues = {
    driversLicense: null,
    driversLicenseNumber: "",
    driversLicenseIssueDate: null,
    driversLicenseType: "",
    driversLicenseIssueCountry: "",
};

export const defaultValues: FormType = {
    id: null,

    ...personDefaultValues,
    ...personalInfoDefaultValues,
    ...financeDefaultValues,
    ...driverLicenseDefaultValues,

    ...communicationBaseDefaultValues,
    ...identityCardBaseDefaultValues,
};

export const mapRequestFamilyMember = (request: FormType, policyHolderId: number): MyBrokerApi.PersonalDetails => {
    return {
        policyHolderId,
        personalTitle: {
            id: request.title,
        },
        firstName: request.firstName,
        lastName: request.lastName,
        gender: {
            id: request.gender,
        },
        maritalStatus: {
            id: request.civilStatus,
        },
        birthdate: request?.birthdate,
        birthPlace: request.birthPlace,
        nationality: { id: request.identityCardNationality },
        language: {
            id: request.language,
        },
        // isPhysicalPerson: true,
        bankAccount: {
            type: {
                id: request.financeAccountType,
            },
            number: request.financeAccount,
        },
        identityCard: {
            issuedBy: request.identityCardAuthority,
            number: request.identityCardNumber,
            validFrom: request?.identityCardValidFrom,
            validTo: request?.identityCardValidTo,
            nationalNumber: request.identityCardNationalNumber,
        },
        driversLicense: {
            number: request.driversLicenseNumber,
            issueDate: request?.driversLicenseIssueDate,
            type: {
                id: request.driversLicenseType,
            },
            issueCountry: {
                id: request.driversLicenseIssueCountry,
            },
        },
        profession: {
            socialStatus: {
                id: request.socialStatus,
            },
        },
        contact: {
            phone0: request.phone0,
            typePhone0: {
                id: request.phone0 ? request.typePhone0 : "",
            },
            phone1: request.phone1,
            typePhone1: {
                id: request.typePhone1,
            },
            phone2: request.phone2,
            typePhone2: {
                id: request.typePhone2,
            },
            email0: request.email0,
            email1: request.email1,
        },
    };
};
